import { FC } from 'react'
import { ChipStatusWrapper } from './productAccordionChip.styles'
import { SSMProductStatus } from '../../../../../models'

interface Props {
  status: SSMProductStatus
}

const ProductAccordionChip: FC<Props> = ({ status }) => {
  return (
    <ChipStatusWrapper className="chip-status-wrapper" status={status}>
      {status}
    </ChipStatusWrapper>
  )
}

export default ProductAccordionChip
